var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard0(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.835938 2.64242C0.835937 2.28879 0.976413 1.94965 1.22646 1.69961C1.47651 1.44956 1.81565 1.30908 2.16927 1.30908H6.16927V13.3091H2.16927C1.81565 13.3091 1.47651 13.1686 1.22646 12.9186C0.976413 12.6685 0.835938 12.3294 0.835938 11.9757V2.64242ZM8.83594 1.30908H12.8359C13.1896 1.30908 13.5287 1.44956 13.7787 1.69961C14.0288 1.94965 14.1693 2.28879 14.1693 2.64242V5.97575H8.83594V1.30908ZM8.83594 8.64242H14.1693V11.9757C14.1693 12.3294 14.0288 12.6685 13.7787 12.9186C13.5287 13.1686 13.1896 13.3091 12.8359 13.3091H8.83594V8.64242Z",
    stroke: "#EBF0F3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard0);
export default __webpack_public_path__ + "static/media/dashboard_0.e5bf54f3032d32b707c45ed0e2447cd8.svg";
export { ForwardRef as ReactComponent };